import request from '@/common/request'

/** 
 *  create 增
 *  delete 删
 *  update 改
 *  query  查
*/
export default {
  createDownTransferTask: (dynaSeg, data, params) => {
    return request({
      url: '/downTransferTask',
      method: 'post',
      data,
      params
    })
  },
  deleteDownTransferTask: (dynaSeg, data, params) => {
    return request({
      url: `/downTransferTask/${dynaSeg.id}`,
      method: 'delete',
      data,
      params
    })
  },
  updateDownTransferTask: (dynaSeg, data, params) => {
    return request({
      url: `/downTransferTask/${dynaSeg.id}`,
      method: 'put',
      data,
      params
    })
  },
  queryDownTransferTask: params => {
    return request({
      url: '/downTransferTask',
      method: 'get',
      params
    })
  },
  reExecTask:params =>{
    return request({
      url:'/downTransferTask/reExecTask',
      method:'get',
      params
    })
  },
  delAllDownTransfer:()=>{
    return request({
      url:'/downTransferTask/delAllTask',
      method:'delete',
    })
  },
  delFiles:params=>{
    return request({
      url:'/remoteFile/delFiles',
      method:'delete',
      params
    })
  },
  formSubmitDown:(data,config)=>{
    return request({
      url:'/downTransferTask/addTask',
      method:'post',
      data,
      config
    })
  },
  commonSubmitDown:(data,params)=>{
    return request({
      url:'/downTransferTask/array',
      method:'post',
      data,
      params
    })
  },
  remoteFileSelect:()=>{
    return request({
      url:'/remoteFile/listAll',
      method:'get'
    })
  },
  remoteFileManage:params =>{
    return request({
      url:'/remoteFile',
      method:'get',
      params
    })
  },
  fileSubmit:(data,params)=>{
    return request({
      url:'/remoteFile/add',
      method:'post',
      data,
      params
      
    })
  }
}


// WEBPACK FOOTER //
// ./src/api/modules/downTransferTask.js